import { DefaultPageHeader } from 'layouts';
import type { OrganizationDetail } from 'models';
import { Card } from 'ui';
import { useGetOrganizationEntityBreadcrumb } from '../hooks';
import { OrganizationsGivingsList } from './organizations-givings-list';

type P = {
  getPathToGivingDetail: (id: string) => string;
  organization: OrganizationDetail;
};

const OrganizationsGivings = ({ getPathToGivingDetail, organization }: P) => {
  const breadcrumbRoutes = useGetOrganizationEntityBreadcrumb({ entityType: 'givings', organization });

  return (
    <>
      <DefaultPageHeader routes={breadcrumbRoutes} title="Giving" />
      <Card>
        <OrganizationsGivingsList getPathToGivingDetail={getPathToGivingDetail} organizationId={organization.id} />
      </Card>
    </>
  );
};

export default OrganizationsGivings;
